<input
  nz-input
  class="editor-input"
  [(ngModel)]="value"
  [disabled]="saving"
  (keydown.enter)="onEnter()"
  (keydown.escape)="onEscape()"
  autofocus
/>
